<template>
  <div class="maxpage-box">
    <div class="item-box">
      <div class="item-title">{{item.title||'--'}}</div>
      <!-- 是专页 -->
      <div v-if="item.detail" class="yes-zhuanye">
        <div class="item-contern">
          <div class="itemcimg-box">
            <van-image class="itemc-img" :src="item.indexPic" />
            <div class="img-per flex_c_m">{{item.num||'--'}}票</div>
          </div>
          {{item.description||'--'}}
        </div>
        <div class="foor-bot flex_c_m">
          <div class="foor-right flex_c_ri">
            <van-button size="small" type="default" class="btn-green" @click="setVote(item)">投一票</van-button>
            <van-button size="small" type="default" class="btn-border" style="margin-left:6px" @click="shaerfind">分享给朋友</van-button>
          </div>
        </div>
      </div>
    </div>
    <div class="pagehtml" v-html="item.detail"></div>
     <div class="back-box" @click="back()"><img class="back" src="../../assets/images/activity/back.png" alt=""></div>
  </div>
</template>

<script>
import {setLocal,getLocal} from '@utils/tools.js'
import {
  wxTools
} from '@utils'
export default {
  data(){
    return{
      item:{},
      zhutiInfo: {}
    }
  },
  created() {
    let token = localStorage.getItem('token')
    if (!token) {
      if (this.$route.query.code) {
        this.$api.user.getWxUser({
					code: this.$route.query.code
				}, res => {
					if(res.data && res.data.token && res.data.token != 'undefined'){
						localStorage.setItem('token', res.data.token)
					}
				})
      } else {
        new wxTools().getCode({
          securityUrl: encodeURIComponent(window.location.href),
          state: ''
        })
      }
    }
  },
  mounted(){
    this.init(this.$route.query.id);
    this.getZhutiDetail()
  },
  methods:{
    back(){
      this.$router.push({path:'/lineVote', query: {voteCode: this.$route.query.voteCode}})
    },
    // 初始化
    init(id){
      this.$api.lineVote.getPageDetail({id},res=>{
        this.item = res.data;
        document.title = res.data.title
        console.log(document.title)
      })
    },
    isDuringDate() {
			var curDate = new Date().getTime()
				
			if (curDate < this.zhutiInfo.voteStartTimestamp) {
				this.$dialog.alert({
					title: '温馨提示',
					message: '活动未开始，请先关注公众号！'
					// message: `投票开始时间还未到！将于 `+this.zhutiInfo.voteStartTime+` 开始投票！`,
				}).then(() => {
					
				});
				return false;
			}else if(curDate > this.zhutiInfo.voteEndTimestamp){
				this.$dialog.alert({
					title: '温馨提示',
					message: `投票时间已经于`+this.zhutiInfo.voteEndTime+' 结束！',
				}).then(() => {
					
				});
				return false;
			}
			return true;
		},
    // 获取主题详情
    getZhutiDetail(){
      this.$api.lineVote.getZhutiDetail({code:this.$route.query.voteCode},res=>{
        this.zhutiInfo = res.data;
      })
    },
    // 投一票
    setVote(item){
      if (!this.isDuringDate()) {
				return
			}
      let uinfo = getLocal({key:'userInfo',parse:true});
      let wxinfo = uinfo?uinfo.wx:{};
      let wxUserInfo = uinfo&&uinfo.user?uinfo.user:{};
      let {openid=undefined} = wxinfo;
      let userId = wxUserInfo.id;
      let param = {
        openid:openid,
        userId:userId,
        voteId:item.voteId,
        voteItemId:item.id,
      }
      this.$api.lineVote.setVote(param,res=>{
        if(res.data) {
          this.$toast('投票成功');
          this.item.num = res.data;
          return
        }

        this.$toast(res.msg)
      },err=>{
        // if (err.code == 501) {
        // 	this.$dialog.alert({
        // 		title: '温馨提示',
        // 		message: '今日投票已达上限！' // err.msg,
        // 	}).then(() => {
        //     /*
        // 		this.$router.push({
        // 			path: '/registered',
        // 			query: {
        // 				voteId: item.voteId,
				// 		    voteCode:this.$route.query.voteCode
        // 			}
        //     })
        //     */
        // 	});
        // }
      })
    },
    // 分享给朋友
    shaerfind(){
      this.$toast('请点击右上角分享');
    },
  }
}
</script>

<style lang="scss" scoped>
.item-box{
  background-color: #fff;
  padding: 15px;
  padding-left: 15px;
  margin-bottom: 10px;
  position: relative;
  &::before{
    content: attr(data-num);
    font-size: 16px;
    color: #333;
    position: absolute;
    left: 15px;
    top: 15px;
  }
  .item-title{
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
  }
  .item-contern{
    font-size: 14px;
    color: #666;
    .itemc-img{
      height: 200px;
      width: 100%;
    }
  }
  .foor-bot{
    margin-top: 10px;
    .foor-right{
      text-align: right;
      width: 100%;
    }
  }
  .yes-zhuanye{
    .itemcimg-box{
      position: relative;
      height: 200px;
      .img-per{
        width:110px;
        height:32px;
        background: url('~@assets/images/icon/baiobiaobiao.png') no-repeat 10px center;
        background-size: 19px 19px;
        background-color:rgba(56,199,180,0.9);
        border-radius:0px 5px 0px 0px;
        font-size: 14px;
        color: #fff;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .foor-left{
      padding-right: 10px;
    }
  }
}
.pagehtml {
  margin-top: 10px;
  background-color: #fff;
  font-size: 14px;
  min-height: 500px;
  padding: 15px;
  img {
    max-width: 100%!important;
  }

  ::v-deep p {
    margin: 0.5em 0
  }

  ::v-deep iframe.ql-video {
    margin: 0 auto;
    display: flex;
    width: 100%;
    min-height: 200px;
  }
}

.back-box {
  position: fixed;
  right: 2px;
  bottom: 20px;
  display: inline-block;
  text-align: right;
  border-radius: 10px
}
.back {
  width: 38px;
  height: auto;
}
</style>
<style>
img {
  max-width: 100%;
}
</style>
